import { Clickable } from '@carvana/merch-components';
import HeartWithBorder from '~/icons/HeartWithBorder';
import { abbreviateLargeNumber } from '~/utilities';
import { Content } from './SocialProof.styles';

type OwnProps = {
  count: number;
  handleClick: () => void;
  isFavorited: boolean;
};

const Saved = ({ count, handleClick, isFavorited }: OwnProps) => {
  const getCopy = () => {
    if (!count) {
      return 'Be the First!';
    }
    if (count === 1) {
      return 'Person Has Saved';
    }

    return 'People Have Saved';
  };

  return (
    <Content data-qa="Social-Proof-Saved">
      <Clickable
        className="flex"
        data-analytics-id="Social Proof - Favorite Icon"
        onClick={handleClick}
        title="Add to Favorites"
      >
        <HeartWithBorder isFavorited={isFavorited} />
        <span className="sr-only">Add to Favorites</span>
      </Clickable>
      <span className="count">{abbreviateLargeNumber(count)}</span>
      <span className="copy">{getCopy()} </span>
    </Content>
  );
};

export default Saved;
